import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/auth/Login.vue";
import Password from "../views/auth/Password.vue";
import Profile from "../views/auth/Profile.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      needsAuth: false,
      menu: "Home",
    },
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      needsAuth: false,
      menu: "Login",
    },
    component: Login,
  },
  {
    path: "/password",
    name: "Password",
    meta: {
      needsAuth: false,
      menu: "Password",
    },
    component: Password,
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      needsAuth: true,
      menu: "Profile",
    },
    component: Profile,
  },
  {
    path: "/about",
    name: "About",
    meta: {
      needsAuth: true,
      menu: "About",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/nastavitve",
    name: "Settings",
    meta: {
      needsAuth: true,
      menu: "Settings",
    },
    component: () => import(/* webpackChunkName: "about" */ "../views/Settings.vue"),
  },
  {
    path: "/skode",
    name: "Skode",
    meta: {
      needsAuth: true,
      menu: "Skode",
    },
    // route level code-splitting
    // this generates a separate chunk (skode.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "skode" */ "../views/Skode.vue"),
  },
  {
    path: "/skode/report",
    name: "SkodeReport",
    meta: {
      needsAuth: true,
      menu: "Skode",
    },
    component: () => import(/* webpackChunkName: "skode" */ "../views/Skode/SkodeReport.vue"),
  },
  {
    path: "/skode/nova",
    name: "SkodeNew",
    meta: {
      needsAuth: true,
      menu: "Skode",
    },
    component: () => import(/* webpackChunkName: "skode" */ "../views/Skode/SkodeNew.vue"),
  },
  {
    path: "/skode/:id/uredi",
    name: "SkodeEdit",
    meta: {
      needsAuth: true,
      menu: "Skode",
    },
    component: () => import(/* webpackChunkName: "skode" */ "../views/Skode/SkodeEdit.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  // console.log("gremo na :", to);
  // console.log("rabi auth :", to.meta.needsAuth);

  let user = localStorage.getItem("user");
  if (to.meta.needsAuth && !user)
    next({
      name: "Login",
    });
  else next();
});

export default router;
